import React from 'react';
import PropTypes from 'prop-types';

import { ANavigationLink } from './';

export default class ANavigationDropDown extends React.Component {
	constructor(props) {
		super(props);
		this.bindHandles();
	}

	componentDidMount() {
		document.addEventListener('mousedown', this.handleClickOutside);
	}

	componentWillUnmount() {
		document.removeEventListener('mousedown', this.handleClickOutside);
	}

	bindHandles() {
		this.handleWrapperRef = this.handleWrapperRef.bind(this);
		this.handleClickOutside = this.handleClickOutside.bind(this);
	}

	handleWrapperRef(node) {
		this.wrapperRef = node;
	}

	handleClickOutside(event) {
		if (this.props.clickOutSide && this.wrapperRef && !this.wrapperRef.contains(event.target)) {
			this.props.clickOutSide();
		}
	}

	render() {
		return (
			<ul className="a-navigation--drop-down" ref={this.handleWrapperRef}>
				{
					this.props.items.map(item => (<ANavigationLink
						key={item.name}
						name={item.name}
						href={item.href}
						onClick={this.props.onClick}
					/>))

				}
			</ul>
		);
	}
}

ANavigationDropDown.propTypes = {
	items: PropTypes.array.isRequired,
	clickOutSide: PropTypes.func.isRequired,
	onClick: PropTypes.func,
};

ANavigationDropDown.defaultProps = {
	onClick: '',
};



// WEBPACK FOOTER //
// ./src/components/atoms/_atoms.navigation-drop-down.js